function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
import React, { useState } from 'react';
import Modal from 'react-modal';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { useTranslate, T } from 'shared/helper/translate';
import Files, { endpoints } from 'shared/helper/file';
import { FILE_STATUS } from 'shared/helper/file/constants';
import { Controls, useFormHelpers, validators } from 'shared/helper/form';
import { convertFormDataToDigitalEditUpdateRequest } from 'shared/view/digital-edit-conversion-service';
import FileRubriq from 'shared/helper/file/components/FileRubriq';
import { createDigitalEdit } from 'researcher/digital-editing/actions';
import featureEnabled from 'shared/helper/feature';
import { syncUser } from '../actions';
import RubriqUploadButton from './RubriqUploadButton';
var fileType = 'digitalEdit';
var Errors = Controls.Errors,
  Form = Controls.Form,
  Radio = Controls.Radio;
var notEmpty = validators.notEmpty;
var defaultValues = {
  digitalEditFiles: [],
  styleOfEnglish: '',
  version: ''
};
var CheckDocumentModal = function CheckDocumentModal(_ref) {
  var _screens$currentPageI;
  var open = _ref.open,
    onClose = _ref.onClose;
  var _useTranslate = useTranslate(),
    t = _useTranslate.t;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    submitting = _useState2[0],
    setSubmitting = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    dragActive = _useState4[0],
    setDragActive = _useState4[1];
  var _useState5 = useState(0),
    _useState6 = _slicedToArray(_useState5, 2),
    currentPageIndex = _useState6[0],
    setCurrentPageIndex = _useState6[1];
  var _useState7 = useState(false),
    _useState8 = _slicedToArray(_useState7, 2),
    showError = _useState8[0],
    setShowError = _useState8[1];
  var rubriqNewLewisVersionEnabled = featureEnabled('rubriq_lewis_version');
  var methods = useForm({
    defaultValues: defaultValues,
    shouldFocusError: false
  });
  var digitalEditFiles;
  var styleOfEnglish;
  var version;
  if (rubriqNewLewisVersionEnabled) {
    var _methods$watch = methods.watch(['digitalEditFiles', 'styleOfEnglish', 'version']);
    var _methods$watch2 = _slicedToArray(_methods$watch, 3);
    digitalEditFiles = _methods$watch2[0];
    styleOfEnglish = _methods$watch2[1];
    version = _methods$watch2[2];
  } else {
    var _methods$watch3 = methods.watch(['digitalEditFiles', 'styleOfEnglish']);
    var _methods$watch4 = _slicedToArray(_methods$watch3, 2);
    digitalEditFiles = _methods$watch4[0];
    styleOfEnglish = _methods$watch4[1];
  }
  var hasFile = digitalEditFiles && digitalEditFiles.length > 0;
  var _useFormHelpers = useFormHelpers(),
    preprocessData = _useFormHelpers.preprocessData;
  var dispatch = useDispatch();
  var radioStyles = featureEnabled('rubriq_lewis_version') ? {
    label: 'text-secondary text-transform-none bolder',
    formCheck: 'form-check-inline me-4 option-bold option-item-width',
    wrapper: 'd-flex flex-row pb-0'
  } : {
    label: 'text-secondary text-transform-none',
    formCheck: 'mb-3',
    wrapper: 'curie-control-group pb-0'
  };
  var isValidPreference = featureEnabled('rubriq_lewis_version') ? function () {
    return !!styleOfEnglish && !!version;
  } : function () {
    return !!styleOfEnglish;
  };
  var wordCountAttempts = 0;
  var screens = [{
    title: /*#__PURE__*/React.createElement(T, {
      source: "upload-document"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
      className: "".concat(digitalEditFiles.length === 0 ? 'submit-digital-edit-form p-3 py-5 mt-2' : '', " ").concat(dragActive ? 'hovered' : ''),
      style: {
        backgroundColor: digitalEditFiles.length === 0 ? '#FAFAFA' : ''
      }
    }, /*#__PURE__*/React.createElement(Files, {
      apiRoot: endpoints.researcher,
      maxUploads: 1,
      methods: methods,
      name: "digitalEditFiles",
      type: fileType,
      disabled: submitting,
      fileRenderer: FileRubriq,
      required: true,
      fileUploadButton: function fileUploadButton(_ref2) {
        var onClick = _ref2.onClick,
          isDragActive = _ref2.isDragActive,
          disabled = _ref2.disabled;
        return /*#__PURE__*/React.createElement(RubriqUploadButton, {
          onClick: onClick,
          isDragActive: isDragActive,
          disabled: disabled,
          onDragStatusChanged: function onDragStatusChanged(active) {
            return setDragActive(active);
          },
          hasFile: hasFile
        });
      }
    }), digitalEditFiles.length === 0 && /*#__PURE__*/React.createElement("label", {
      className: "control-label text-secondary text-transform-none text-center w-100 me-3 ms-e"
    }, /*#__PURE__*/React.createElement(T, {
      source: "curie-file-upload-requirements",
      params: {
        wordLimit: '25,000'
      }
    }))), showError && /*#__PURE__*/React.createElement("div", {
      className: "text-danger mt-3"
    }, /*#__PURE__*/React.createElement(T, {
      source: "file-upload-error"
    }))),
    isValid: function isValid() {
      return hasFile && digitalEditFiles.every(function (file) {
        return file.status === FILE_STATUS.STATUS_UPLOAD_SUCCESS;
      });
    }
  }, {
    title: featureEnabled('rubriq_lewis_version') ? /*#__PURE__*/React.createElement(T, {
      source: "rubriq.editing-preference"
    }) : /*#__PURE__*/React.createElement(T, {
      source: "language-preference"
    }),
    content: /*#__PURE__*/React.createElement(React.Fragment, null, rubriqNewLewisVersionEnabled ? /*#__PURE__*/React.createElement("p", {
      className: "fw-bold",
      style: {
        fontSize: '0.95rem'
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-language",
      className: "font-color-editing-label"
    }), /*#__PURE__*/React.createElement(T, {
      source: "style of english"
    })) : /*#__PURE__*/React.createElement("p", {
      className: "fw-semibold",
      style: {
        fontSize: '1rem'
      }
    }, /*#__PURE__*/React.createElement(T, {
      source: "style of english"
    })), rubriqNewLewisVersionEnabled ? /*#__PURE__*/React.createElement("label", {
      htmlFor: "styleOfEnglish",
      style: {
        fontSize: '0.875rem'
      },
      className: "editing-light-grey mb-3"
    }, /*#__PURE__*/React.createElement("span", {
      className: "editing-light-grey"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.style-of-english-label-editing"
    }))) : /*#__PURE__*/React.createElement("label", {
      htmlFor: "styleOfEnglish",
      style: {
        fontSize: '0.875rem'
      },
      className: "mb-3"
    }, /*#__PURE__*/React.createElement(T, {
      source: "style-of-english-label"
    })), /*#__PURE__*/React.createElement(Radio, {
      name: "styleOfEnglish",
      validators: {
        notEmpty: notEmpty
      },
      styles: radioStyles,
      options: [{
        value: 'American English',
        label: /*#__PURE__*/React.createElement(T, {
          source: "American English"
        })
      }, {
        value: 'British English',
        label: /*#__PURE__*/React.createElement(T, {
          source: "British English"
        })
      }]
    }), /*#__PURE__*/React.createElement(Errors, {
      name: "styleOfEnglish",
      messages: {
        notEmpty: 'curie.digital-translation-styleOfEnglish-empty-error'
      },
      wrapper: "p"
    }), rubriqNewLewisVersionEnabled ? /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("hr", {
      className: "hr-gradient"
    }), /*#__PURE__*/React.createElement("p", {
      className: "fw-bold",
      style: {
        fontSize: '0.95rem'
      }
    }, /*#__PURE__*/React.createElement(FontAwesomeIcon, {
      icon: "fa-solid fa-gauge-simple-high",
      className: "font-color-editing-label"
    }), /*#__PURE__*/React.createElement(T, {
      source: "rubriq.lewis-version"
    })), /*#__PURE__*/React.createElement("label", {
      htmlFor: "version",
      style: {
        fontSize: '0.875rem'
      },
      className: "editing-light-grey mb-3"
    }, /*#__PURE__*/React.createElement("span", {
      className: "editing-light-grey"
    }, /*#__PURE__*/React.createElement(T, {
      source: "rubriq.select-lewis-version-label"
    }))), /*#__PURE__*/React.createElement(Radio, {
      name: "version",
      validators: {
        notEmpty: notEmpty
      },
      styles: {
        label: 'text-secondary text-transform-none bolder',
        formCheck: 'form-check-inline me-4 option-bold option-item-width',
        wrapper: 'd-flex flex-row pb-0'
      },
      options: [{
        value: '1.7.0',
        label: /*#__PURE__*/React.createElement(T, {
          source: "rubriq.moderate-edits"
        })
      }, {
        value: '1.8.4',
        label: /*#__PURE__*/React.createElement(T, {
          source: "rubriq.high-edits"
        })
      }]
    }), /*#__PURE__*/React.createElement(Errors, {
      name: "version",
      messages: {
        notEmpty: 'rubriq.digital-edit-version-empty-error'
      },
      wrapper: "p"
    })) : ''),
    isValid: function isValid() {
      return isValidPreference;
    }
  }];
  var close = function close(result) {
    var errorId = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    setSubmitting(false);
    methods.reset(defaultValues);
    setCurrentPageIndex(0);
    setShowError(false);
    wordCountAttempts = 0;
    onClose(result, errorId);
  };
  var handleClickNext = function handleClickNext() {
    if (screens[currentPageIndex].isValid()) {
      setShowError(false);
      if (currentPageIndex < screens.length - 1) {
        setCurrentPageIndex(currentPageIndex + 1);
      }
    } else {
      setShowError(true);
    }
  };
  var handleSubmit = function handleSubmit() {
    methods.handleSubmit(preprocessData(convertFormDataToDigitalEditUpdateRequest, _submitDigitalEdit))();
  };
  var _submitDigitalEdit = function submitDigitalEdit(data) {
    setSubmitting(true);
    dispatch(createDigitalEdit(data, false, false)).then(function (res) {
      var digitalEditError = res.error;
      if (digitalEditError) {
        var errorId = digitalEditError.error;
        if (errorId === 'word-count-not-received') {
          if (wordCountAttempts < 12) {
            setTimeout(_submitDigitalEdit(data), 5000);
            wordCountAttempts += 1;
            return;
          }
        }
        close(false, errorId);
      } else {
        // make sure the number of digital edits used is updated
        dispatch(syncUser()).then(function () {
          close(true);
        });
      }
    });
  };
  return /*#__PURE__*/React.createElement(React.Fragment, null, open && /*#__PURE__*/React.createElement(Modal, {
    appElement: document.querySelector('#researcher-app'),
    isOpen: true,
    overlayClassName: "react-modal-overlay",
    className: "react-modal modal-padding"
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-header"
  }, /*#__PURE__*/React.createElement("button", {
    type: "button",
    className: "btn-close",
    onClick: function onClick() {
      return close(false);
    },
    "aria-label": t('close')
  }, /*#__PURE__*/React.createElement("span", {
    "aria-hidden": "true"
  }, "\xD7")), /*#__PURE__*/React.createElement("h1", {
    className: "react-modal-title ".concat(((_screens$currentPageI = screens[currentPageIndex].title) === null || _screens$currentPageI === void 0 || (_screens$currentPageI = _screens$currentPageI.props) === null || _screens$currentPageI === void 0 ? void 0 : _screens$currentPageI.source) === 'rubriq.editing-preference' ? 'modal-heading-overide' : '')
  }, screens[currentPageIndex].title)), /*#__PURE__*/React.createElement(Form, {
    methods: methods,
    onSubmit: handleSubmit
  }, /*#__PURE__*/React.createElement("div", {
    className: "react-modal-content",
    style: {
      height: 341
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "digital-edits adjust-body-content"
  }, screens[currentPageIndex].content)), /*#__PURE__*/React.createElement("div", {
    className: "react-modal-footer"
  }, currentPageIndex === screens.length - 1 ? /*#__PURE__*/React.createElement("button", {
    type: "submit",
    disabled: submitting || !isValidPreference(),
    className: "btn btn-primary btn-squared me-3",
    key: "start"
  }, /*#__PURE__*/React.createElement(T, {
    source: "start"
  }), submitting ? /*#__PURE__*/React.createElement(FontAwesomeIcon, {
    className: "ms-1",
    icon: "fa-solid fa-spinner-scale",
    spin: true
  }) : null) : /*#__PURE__*/React.createElement("button", {
    "aria-label": t('continue'),
    type: "button",
    onClick: handleClickNext,
    className: "btn btn-primary btn-squared me-3",
    key: "continue"
  }, /*#__PURE__*/React.createElement(T, {
    source: "continue"
  })), /*#__PURE__*/React.createElement("button", {
    "aria-label": t('cancel'),
    type: "button",
    onClick: function onClick() {
      return close(false);
    },
    className: "btn btn-secondary btn-squared"
  }, /*#__PURE__*/React.createElement(T, {
    source: "cancel"
  }))))));
};
export default CheckDocumentModal;